<template>
    <span class="favorite-search-icon" aria-hidden="true">
        <v-icon size="22">mdi-magnify</v-icon>
        <v-icon size="12" class="favorite-search-heart">mdi-heart</v-icon>
    </span>
</template>

<script>
export default {
    name: 'FavoriteSearchIcon',
}
</script>

<style scoped>
.favorite-search-icon {
    position: relative;
    display: inline-flex;
    flex: none;
    width: 22px;
    height: 22px;
}

.favorite-search-heart.v-icon {
    position: absolute;
    right: -3px;
    top: -1px;
}
</style>
